import moment from "moment";

export const searchProjects = (allProjects, val) => {
  let newProjList = [];
  let filterVal = val.toLowerCase();
  //console.log('filter val is: '+filterVal)
  let searchResult = false;
  newProjList = allProjects.filter(proj => {
    if (proj.projectAddress && proj.projectAddress !== undefined) {
      //console.log("Here is address: "+proj.projectAddress+" " +(proj.projectAddress.toLowerCase().includes(filterVal)))
      searchResult = proj.projectAddress.toLowerCase().includes(filterVal);
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress itemCount in newProjList " + newProjList.length)
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    if (proj.projectPhase && proj.projectPhase !== undefined) {
      //console.log("Here is phase: "+proj.projectPhase+" " +(proj.projectPhase.toLowerCase().includes(filterVal)))
      searchResult = proj.projectPhase.toLowerCase().includes(filterVal);
      //console.log(searchResult + " filter val is: " +filterVal+" actual: "+ proj.projectPhase+" projPhase itemCount in newProjList " + newProjList.length)
      //console.log(searchResult+ " filter val is: " +filterVal+" actual: "+ proj.projectPhase+"projPhase items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    if (proj.projectName && proj.projectName !== undefined) {
      //console.log("Here is name: "+proj.projectName+" " +(proj.projectName.toLowerCase().includes(filterVal)))
      searchResult = proj.projectName.toLowerCase().includes(filterVal);
      //console.log(searchResult + " filterVal: " +filterVal+" actual: "+ proj.projectName+" projName itemCount in newProjList " + newProjList.length)
      //console.log(searchResult + " filterVal: " +filterVal+" actual: "+ proj.projectName+" projName items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    return false;
  });

  return newProjList;
};

export const searchAttendance = (allAttendance, val) => {
  let newAttList = [];
  let filterVal = val.toLowerCase();
  //console.log('filter val is: '+filterVal)
  let searchResult = false;
  newAttList = allAttendance.filter(att => {
    if (att.employeeName && att.employeeName !== undefined) {
      //console.log("Here is name: "+att.employeeName+" " +(att.employeeName.toLowerCase().includes(filterVal)))
      searchResult = att.employeeName.toLowerCase().includes(filterVal);
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    if (att.startDateTime && att.startDateTime !== undefined) {
      let date1 = moment(att.startDateTime, "DD-MM-YYYY h:mm a").format();
      let dateVal = moment(date1).format("DD-MMM-YYYY(dddd)");
      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
      searchResult = dateVal.toLowerCase().includes(filterVal);
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    if (att.attStatus && att.attStatus !== undefined) {
      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
      searchResult = att.attStatus.toLowerCase().includes(filterVal);
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    if (att.projectName && att.projectName !== undefined) {
      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
      searchResult = att.projectName.toLowerCase().includes(filterVal);
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    if (att.attendanceWorkType && att.attendanceWorkType !== undefined) {
      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
      searchResult = att.attendanceWorkType.toLowerCase().includes(filterVal);
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
      if (searchResult) {
        return searchResult;
      }
    }

    return false;
  });

  return newAttList;
};

const applyDateFilters = (allRecords, searchDateFilters) => {
  //console.log("Applying Date Filters: " + JSON.stringify(searchDateFilters));
  let newList = [];

  if (
    !searchDateFilters ||
    searchDateFilters === undefined ||
    !allRecords ||
    allRecords.length < 1
  ) {
    return allRecords;
  }

  let fromDateStr = searchDateFilters.FromDate;
  let toDateStr = searchDateFilters.ToDate;
  let momFromDate = moment();
  let momToDate = moment();

  if (fromDateStr !== undefined) {
    momFromDate = moment(fromDateStr, "DD-MM-YYYY");
  }
  if (toDateStr !== undefined) {
    momToDate = moment(toDateStr, "DD-MM-YYYY");
    if (searchDateFilters.tgtDateFormat === "DD-MM-YYYY h:mm a") {
      //console.log("added a day");
      momToDate = momToDate.add(1, "day");
    } else {
      //console.log("no added days: " + searchDateFilters.tgtDateFormat);
    }
  }

  // console.log(
  //   " fromSelection:" +
  //     momFromDate.toString() +
  //     " toSelection:" +
  //     momToDate.toString()
  // );

  if (
    !fromDateStr &&
    fromDateStr === undefined &&
    !toDateStr &&
    toDateStr === undefined
  ) {
    return allRecords;
  } else {
    // console.log(
    //   "tgtFieldIs: " +
    //     searchDateFilters.tgtDateField +
    //     " " +
    //     JSON.stringify(searchDateFilters)
    // );
    newList = allRecords.filter(rec => {
      //console.log("this is record: " + JSON.stringify(rec));
      let tgtDateStr = rec[searchDateFilters.tgtDateField];
      let momTgtDate = moment(tgtDateStr, searchDateFilters.tgtDateFormat);

      let result = true;

      if (fromDateStr && fromDateStr !== undefined) {
        if (momTgtDate.isBefore(momFromDate)) {
          result = false;
        }
      }
      if (toDateStr && toDateStr !== undefined) {
        if (momTgtDate.isAfter(momToDate)) {
          result = false;
        }
      }

      // console.log(
      //   searchDateFilters.tgtDateField +
      //     " tgt: " +
      //     tgtDateStr +
      //     " fromSelection:" +
      //     fromDateStr +
      //     " toSelection:" +
      //     toDateStr +
      //     " result:" +
      //     result
      // );

      return result;
    });
    return newList;
  }
};

const applyFilters = (allRecords, searchFilters, searchDateFilters) => {
  //console.log("Applying Filters");
  let newDatedList = applyDateFilters(allRecords, searchDateFilters);
  let newFileteredList = [];

  if (
    !searchFilters ||
    searchFilters === undefined ||
    !allRecords ||
    allRecords.length < 1
  ) {
    return newDatedList;
  }

  let filterKeys = Object.keys(searchFilters);

  if (!filterKeys || filterKeys === undefined || filterKeys.length < 1) {
    return newDatedList;
  } else {
    newFileteredList = newDatedList.filter(rec => {
      let result = true;
      for (let i = 0; i < filterKeys.length; i++) {
        let str1 = rec[filterKeys[i]];
        let str2 = searchFilters[filterKeys[i]];
        if (str1 && str1 !== "" && str2 && str2 !== "") {
          if (str1.trim() !== str2.trim()) {
            result = false;
          }
        } else {
          result = false;
        }
      }
      return result;
    });
    return newFileteredList;
  }
};

export const searchRecords = (
  allSourceRecords,
  val,
  fieldsList,
  searchFilters,
  searchDateFilters,
  cellPhone
) => {
  // console.log(
  //   allSourceRecords.length +
  //     " " +
  //     val +
  //     " " +
  //     JSON.stringify(fieldsList) +
  //     " " +
  //     cellPhone
  // );
  if (
    !allSourceRecords ||
    allSourceRecords === undefined ||
    allSourceRecords.length < 1
  ) {
    return [];
  }
  let newList = [];
  let allRecords = applyFilters(
    allSourceRecords,
    searchFilters,
    searchDateFilters
  );
  if (allRecords && allRecords !== undefined && fieldsList !== undefined) {
    let filterVal = val.toLowerCase();
    // if (filterVal === "525") {
    //   console.log("1212: filter val is: " + filterVal);
    // }
    let searchResult = false;
    newList = allRecords.filter(rec => {
      //console.log("filter: " + JSON.stringify(rec));
      if (cellPhone && cellPhone !== undefined) {
        //console.log("checking mobile number");
        if (rec["mobile"] && rec["mobile"] !== undefined) {
          if (
            rec["mobile"] !== cellPhone &&
            rec["mobile"] !== "+65" + cellPhone
          ) {
            return false;
          }
        }
      }
      //console.log("passed through: " + fieldsList.length);
      for (let i = 0; i < fieldsList.length; i++) {
        if (
          rec[fieldsList[i]] &&
          rec[fieldsList[i]] !== undefined &&
          rec[fieldsList[i]] !== ""
        ) {
          //console.log("checking field val: ");
          let recVal = rec[fieldsList[i]];
          // if (filterVal === "nur") {
          //   console.log("1212: field is : " + fieldsList[i]);
          //   console.log(
          //     "1212: value is : " + rec[fieldsList[i]] + typeof recVal
          //   );
          // }
          if (
            recVal &&
            recVal !== undefined &&
            (typeof recVal === "string" || typeof recVal === "number")
          ) {
            if (typeof recVal === "number") {
              recVal = recVal.toString();
            }
            searchResult = recVal.toLowerCase().includes(filterVal);
            // if (filterVal === "nur") {
            //   console.log(
            //     "Here is the recVal: " + recVal + " and result: " + searchResult
            //   );
            // }
            if (searchResult) {
              return searchResult;
            }
          } else {
          }
        }
      }

      if (
        rec.messages &&
        rec.messages !== undefined &&
        rec.messages.length > 0
      ) {
        for (let i = 0; i < rec.messages.length; i++) {
          let recVal = rec.messages[i].msgText;
          let msgRes = recVal.toLowerCase().includes(filterVal);
          if (msgRes) {
            return msgRes;
          }
        }
      }

      return false;
    });
    return newList.slice(0, 1000);
  } else {
    return allRecords.slice(0, 1000);
  }
};



// WEBPACK FOOTER //
// ./src/app/components/searches/searchRecords.js